import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('잠깐!'))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_agree_info = _resolveComponent("agree-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_text, {
      px: "20px",
      typography: "tit18b"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.stakeNameRef) + " 조합원 자격 구매 ", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ag_box, {
      p: "32px 20px",
      direction: "column",
      dp: "flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, { dp: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_img, {
              style: {"flex-shrink":"0"},
              width: "100px",
              height: "100px",
              src: "/assets/image/join_character@2x.png"
            }),
            _createVNode(_component_ag_box, null, {
              default: _withCtx(() => [
                _createVNode(_component_ag_text, {
                  dp: "block",
                  style: {"font-size":"26px","font-weight":"700","line-height":"38px"},
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text, { typography: "tit20b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString('조합의 특성을 이해한 후, 동의하면 구매하세요.'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, { "padding-top": "40px" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreeArray, (agree, idx) => {
              return (_openBlock(), _createBlock(_component_agree_info, {
                key: agree,
                index: idx,
                checked: _ctx.checked[idx],
                agree: agree,
                onRadioClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.print($event)))
              }, null, 8, ["index", "checked", "agree"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}